import { Component } from 'react'
import { Button, Icon } from '@vzmi/shp_shared_compo'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'
import styles from './index.css'
import cx from 'classnames'
import _ from 'lodash'
import Popover from '../Common/Popover'
import { HyperLink } from '../Common/Form'

const images = [
  `${CDN}/supplier/batch-proposal-1_1556100125915.jpg`,
  `${CDN}/supplier/batch-proposal-2_1556100138274.jpg`,
  `${CDN}/supplier/batch-proposal-3_1556100152695.jpg`
]
const EC_MART_MANUAL_URL = 'https://www.ec-mart.com/manual/yahoobuy'

const SP_MAIL = 'tw-supplier-portal@yahooinc.com'

class Introduction extends Component {
  onClick = (url) => {
    window.open(url, '_blank')
  }

  onRequestKeyClick = () => {
    const url = _.get(this.props, 'supplier.sharedLink.scmApiKeyIntroduction', null)
    if (url) {
      this.onClick(url)
    }
  }

  onQueryKeyClick = () => {
    const url = _.get(this.props, 'supplier.sharedLink.scmApiKeyQuery', null)
    if (url) {
      this.onClick(url)
    }
  }

  onDownloadClick = () => {
    this.onClick('https://www.ec-mart.com/yahoobuy/downloads')
  }

  render () {
    const tooltipTitle = '批次提案工具為Yahoo購物中心的合作廠商提供的電腦版軟體，點擊"下載安裝檔"後，即將前往合作廠商之網站進行下載。'
    return (
      <div className={cx(styles.container, styles.introduction)}>

        <div className={styles.row1}>1. 申請或查詢 API Key</div>
        <div className={styles.row2}>
          <Button
            key='request'
            size='large'
            disabled={false}
            data-role='api-key-request'
            onClick={this.onRequestKeyClick}
          >
            申請 API Key
          </Button>
          <Button
            key='query'
            size='large'
            disabled={false}
            data-role='api-key-query'
            buttonType='outline'
            color='primary'
            onClick={this.onQueryKeyClick}
          >
            查詢 API Key
          </Button>
        </div>
        <div className={styles.row1}>
          2. 下載 “批次提案工具” 安裝檔
          <Popover content={tooltipTitle}>
            <Icon
              name={'ec-information-fill'}
              size={17}
              align='top'
              color='#979ba7'
            />
          </Popover>
        </div>
        <div className={styles.row2}>
          <Button
            key='download'
            size='large'
            disabled={false}
            data-role='download-proposal-app'
            buttonType='outline'
            color='primary'
            onClick={this.onDownloadClick}
          >
            下載安裝檔
          </Button>
        </div>
        <div className={styles.row1}>3. 依照您的作業系統選擇適合的版本進行安裝   /   以 API Key 資訊進行登入   /   進入批次提案工具首頁，開始使用提案功能</div>
        <div
          className={cx(styles.row2, styles.moreMargin)}
          data-role='example-images'
        >
          {images.map((element, index) => {
            return (
              <img
                key={index}
                src={element}
              />
            )
          })}
        </div>
        <div className={styles.row1}>
          <p>
            <HyperLink
              href={EC_MART_MANUAL_URL}
              target='_blank'
            >
              購物中心批次提案工具說明中心
            </HyperLink>
          </p>
          <p>
            有任何建議或疑問歡迎來信：
            <HyperLink href={`mailto:${SP_MAIL}`}>
              {SP_MAIL}
            </HyperLink>
          </p>
        </div>
      </div>
    )
  }
}

export default Introduction
